(
    function (skyward, $, undefined)
    {
        skyward.scheduling = skyward.scheduling || {};

        var init = function (selector)
        {
            var courseDetails = $(selector).find('#editCourse');
            if (courseDetails && courseDetails[0])
            {
                var isRequiredCheckbox = courseDetails.find('#editCourse_IsRequired');

                if (isRequiredCheckbox && isRequiredCheckbox[0])
                {
                    $(isRequiredCheckbox[0]).off('change', skyward.scheduling.redefaultSchedulingPriority);
                    $(isRequiredCheckbox[0]).on('change', skyward.scheduling.redefaultSchedulingPriority);
                }
            }

            var setPrimaryClicked = function (e)
            {
                $("#SelectSubjects").find($('[id*="SetPrimary-"]')).each(function (index, element)
                {
                    if (e.target !== element && $(element).prop("checked"))
                    {
                        skyward.controls.setValue($(element), false);
                    }
                });
            };

            var selectBoxChanged = function (e)
            {
                var elementName = $(e.target).attr("name");
                var nameSplit = elementName.split("-");
                var nameID = nameSplit[0];
                var elementID = nameSplit[1];

                var primaryElement = $("#SelectSubjects #SetPrimary-" + elementID);
                skyward.controls.toggle(primaryElement, $(e.target).prop("checked"));

                if (!$(e.target).prop("checked") && primaryElement.prop("checked"))
                {
                    $("#SelectSubjects").find($('[id*="SetPrimary-"]')).each(function (index, element)
                    {
                        if (!$(element).prop("checked") && !$(element).hasClass("ui-disabled"))
                        {
                            $(element).click();
                            return false;
                        }
                        if ($(element).prop("checked"))
                        {
                            skyward.controls.setValue($(element), false);
                        }
                    });
                }
            };

            var massUpdateCourseLengthSelectCourseToUpdateEventHandler = function (event)
            {
                var target = event.target;
                if (target && target.id)
                {
                    if (target.id.split("-")[0] === "SelectedTempCourseID")
                    {
                        var tempCourseID = target.id.split("-")[1];
                        var newCourseLengthCodeEELcode = $("#NewCourseLengthIDCodeEEL-" + tempCourseID + "_code");

                        if (newCourseLengthCodeEELcode && newCourseLengthCodeEELcode[0])
                        {
                            if (target.checked)
                            {
                                newCourseLengthCodeEELcode.focus();
                            }
                        }
                    }
                }
            };

            var walkInIgnoredChanged = function (event)
            {
                var target = event.target;
                if (target && target.id)
                {
                    if (target.id === "StudentCourseRequestsToIgnore_CheckAll")
                    {
                        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
                    }
                    else if (target.id.split("-")[0] === "IgnoredStudentCourseRequest")
                    {
                        var ignoredID = target.id.split("-")[1];
                        var partnerElement = $(this).closest("tr").find("#UnscheduledStudentCourseRequest-" + ignoredID);  //grab sibling

                        if (partnerElement && partnerElement[0])
                        {
                            if (target.checked)
                            {
                                partnerElement.data('checkedBeforeIgnore', skyward.controls.getValue(partnerElement).toString());
                                skyward.controls.disable(partnerElement);
                                skyward.controls.setValue(partnerElement, "true");  //want event to happen so change event skyward.dataobjectviewer.updateCustomSaveData fires
                            }
                            else
                            {
                                skyward.controls.setValue(partnerElement, partnerElement.data('checkedBeforeIgnore')); //want event to happen so change event skyward.dataobjectviewer.updateCustomSaveData fires
                                skyward.controls.enable(partnerElement);
                            }
                        }
                    }
                }
            };

            var estimatedNumberOfSectionsBlurEventHandler = function (event)
            {
                var target = event.target;
                var input = $(this);
                if (target && target.id)
                {
                    if (target.id.split("-")[0] === "EstimatedNumberOfSections")
                    {
                        var tempCourseID = target.id.split("-")[1];
                        var estimatedSections = target.value;
                        var avgPerSectionElement = $(this).closest("tr").find("#EstimatedStudentsPerSection-" + tempCourseID);

                        if (avgPerSectionElement && avgPerSectionElement[0])
                        {
                            var numberOfCourseRequests = $(this).closest("tr").find("#NumberOfCourseRequests-" + tempCourseID);
                            var numberOfCourseRequestsValue = numberOfCourseRequests.val();

                            if (skyward.extensions.isNumeric(target.value) && estimatedSections > 0)
                            {
                                if (skyward.extensions.isNumeric(estimatedSections) && skyward.extensions.isNumeric(numberOfCourseRequestsValue))
                                {
                                    var avgPerSectionValue = parseFloat(numberOfCourseRequestsValue / estimatedSections).toFixed(2);
                                    avgPerSectionElement.val(avgPerSectionValue);
                                }
                            }
                            else
                            {
                                avgPerSectionElement.val(parseFloat(numberOfCourseRequestsValue).toFixed(2));
                                target.value = 1;
                            }
                        }
                    }
                }
            };

            var restoreCheckBoxesChanged = function (event)
            {
                var target = event.target;
                if (target && target.id)
                {
                    if (target.id === "TempStudentCourseRequestToReactivateIDToSchedule_CheckAll")
                    {
                        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
                        if (target.checked)
                        {
                            skyward.controls.setValue($("#TempStudentCourseRequestToReactivateIDToRequest_CheckAll"), "false");
                        }
                    }
                    else if (target.id === "TempStudentCourseRequestToReactivateIDToRequest_CheckAll")
                    {
                        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
                        if (target.checked)
                        {
                            skyward.controls.setValue($("#TempStudentCourseRequestToReactivateIDToSchedule_CheckAll"), "false");
                        }
                    }
                    else if (target.checked)
                    {
                        var pieces = target.id.split("-");
                        var rowPK = pieces[1];
                        var partnerElement;

                        if (pieces[0] === "TempStudentCourseRequestToReactivateIDToRequest")
                        {
                            partnerElement = $(this).closest("tr").find("#TempStudentCourseRequestToReactivateIDToSchedule-" + rowPK);
                        }
                        else if (pieces[0] === "TempStudentCourseRequestToReactivateIDToSchedule")
                        {
                            partnerElement = $(this).closest("tr").find("#TempStudentCourseRequestToReactivateIDToRequest-" + rowPK);
                        }

                        if (partnerElement && partnerElement[0])
                        {
                            skyward.controls.setValue(partnerElement, "false");
                        }
                    }
                }
            };

            if ($("#SelectSubjects").find($('[id*="SetPrimary-"]').length > 0))
            {
                $("#SelectSubjects").find($('[id*="SetPrimary-"]')).each(function (index, element)
                {
                    $(element).on("click", setPrimaryClicked);
                });
            }

            if ($("#SelectSubjects").find($('[id*="SelectSubject-"]').length > 0))
            {
                $("#SelectSubjects").find($('[id*="SelectSubject-"]')).each(function (index, element)
                {
                    $(element).on("change", selectBoxChanged);
                });
            }

            var requestRescheduleRestoreBrowse = $(selector).find('#SelectStudentCourseRequestsToReactivate');
            if (requestRescheduleRestoreBrowse && requestRescheduleRestoreBrowse[0])
            {
                requestRescheduleRestoreBrowse.off('change', "input", null, restoreCheckBoxesChanged);
                requestRescheduleRestoreBrowse.on('change', "input", null, restoreCheckBoxesChanged);
            }

            var walkInIgnoreUnscheduleBrowse = $(selector).find('#BrowseStudentCourseRequests');
            if (walkInIgnoreUnscheduleBrowse && walkInIgnoreUnscheduleBrowse[0])
            {
                walkInIgnoreUnscheduleBrowse.off('change', "input", null, walkInIgnoredChanged);
                walkInIgnoreUnscheduleBrowse.on('change', "input", null, walkInIgnoredChanged);
            }

            var updateEstimatedNumberOfSections = $(selector).find('#UpdateEstimatedNumberOfSectionsBrowseTempCourses');
            if (updateEstimatedNumberOfSections && updateEstimatedNumberOfSections[0])
            {
                updateEstimatedNumberOfSections.off('blur', "input", null, estimatedNumberOfSectionsBlurEventHandler);
                updateEstimatedNumberOfSections.on('blur', "input", null, estimatedNumberOfSectionsBlurEventHandler);
            }

            var scrQuickEntryWorkflowQuickEntry = $(selector).find('#SchedulingGroupQuickEntry');
            if (scrQuickEntryWorkflowQuickEntry && scrQuickEntryWorkflowQuickEntry[0])
            {
                quickAddButton = scrQuickEntryWorkflowQuickEntry.find('#SchedulingGroupQuickAddCourses');

                if (quickAddButton && quickAddButton[0])
                {
                    quickAddButton.off('click', skyward.scheduling.quickentryschedulinggroupintoquickentry);

                    var schedulingGroupCodeEel = scrQuickEntryWorkflowQuickEntry.find('#SchedulingGroupID');
                    var quickAddScope = $(selector).find('#StudentCourseRequestQuickEntry');
                    var quickEntryAddAnotherButton = undefined;
                    if (quickAddScope && quickAddScope[0])
                    {
                        quickEntryAddAnotherButton = quickAddScope.find('div.childrecordquickentryadddiv>a');
                    }

                    if (schedulingGroupCodeEel && schedulingGroupCodeEel[0] && quickEntryAddAnotherButton && quickEntryAddAnotherButton[0])
                    {
                        quickAddButton.on('click', { schedulingGroupCodeEel: schedulingGroupCodeEel, quickAddScope: quickAddScope, addAnotherButton: quickEntryAddAnotherButton }, skyward.scheduling.quickentryschedulinggroupintoquickentry);
                    }
                }
            }

            var massUpdateCourseLength = $(selector).find('#MassUpdateCourseLengthTempCoursesBrowse');
            if (massUpdateCourseLength && massUpdateCourseLength[0])
            {
                massUpdateCourseLength.off('change', "input", null, massUpdateCourseLengthSelectCourseToUpdateEventHandler);
                massUpdateCourseLength.on('change', "input", null, massUpdateCourseLengthSelectCourseToUpdateEventHandler);
            }

            var addSubstituteAssignmentDiv = $(selector).find('#AddSubstituteAssignmentDiv');
            if (addSubstituteAssignmentDiv.length > 0)
            {
                var startDate = addSubstituteAssignmentDiv.find('#StartDate');
                var endDate = addSubstituteAssignmentDiv.find('#EndDate');
                var staff = addSubstituteAssignmentDiv.find('#SourceStaffID_value');
                var sections = addSubstituteAssignmentDiv.find('#SelectedSectionIDs');
                var excludeAssignedSections = addSubstituteAssignmentDiv.find('#ExcludeAssignedSections');
                var calendar = addSubstituteAssignmentDiv.find('#CalendarID_value');
                var applyAllButton = addSubstituteAssignmentDiv.find('#btnApplyToUnassignedSections');
                var clearAllButton = addSubstituteAssignmentDiv.find('#btnClearSections');
                startDate.on('change', updateTempSubstituteAssignments);
                endDate.on('change', updateTempSubstituteAssignments);
                staff.on('change', updateTempSubstituteAssignments);
                sections.on('change', updateTempSubstituteAssignments);
                calendar.on('change', updateTempSubstituteAssignments);
                excludeAssignedSections.on('change', updateTempSubstituteAssignments);
                applyAllButton.on('click', applySubstituteSettingsToUnassignedSections);
                clearAllButton.on('click', clearSubstituteSettingsAllSections);
            }

            var massUpdateStaffForMeetsDiv = $(selector).find('#MassUpdateStaffForMeetsDiv');
            if (massUpdateStaffForMeetsDiv.length > 0)
            {
                var massChangeEndDate = massUpdateStaffForMeetsDiv.find('#EndDate');
                // #EndDate is now the sky-datepicker wrapper, not the input; blur doesn't bubble up from the
                // inner input (and wouldn't fire on a calendar pick), so use the wrapper's bubbling change event.
                massChangeEndDate.on('change', massChangeEndDateBlurEvent);
            }
        };

        var massChangeEndDateBlurEvent = function ()
        {
            var massUpdateStaffForMeetsDiv = $(this).parents('#MassUpdateStaffForMeetsDiv');

            var newEndDate = massUpdateStaffForMeetsDiv.find('#EndDate');
            var newEndDateValue = new Date(skyward.controls.getValue(newEndDate));

            if (newEndDateValue && newEndDateValue.isValidDate())
            {
                var newStartDate = massUpdateStaffForMeetsDiv.find('#StartDate');

                var oldStartDate = new Date(skyward.controls.getValue(newStartDate));
                var oldStartDateValue = (oldStartDate.getMonth() + 1).toString().padLeft(2, '0') + '/' + oldStartDate.getDate().toString().padLeft(2, '0') + '/' + oldStartDate.getFullYear();

                var newEndDatePlusOne = new Date(newEndDateValue);
                newEndDatePlusOne.setDate(newEndDatePlusOne.getDate() + 1);

                var newStartDateValue = (newEndDatePlusOne.getMonth() + 1).toString().padLeft(2, '0') + '/' + newEndDatePlusOne.getDate().toString().padLeft(2, '0') + '/' + newEndDatePlusOne.getFullYear();

                if (newStartDateValue !== oldStartDateValue)
                {
                    skyward.controls.setValue(newStartDate, newStartDateValue);
                }
            }
        };

        var updateTempSubstituteAssignments = skyward.debounce(function ()
        {
            var addSubstituteAssignmentDiv = $(this).parents('#AddSubstituteAssignmentDiv');

            var startDate = addSubstituteAssignmentDiv.find('#StartDate');
            var endDate = addSubstituteAssignmentDiv.find('#EndDate');
            var staff = addSubstituteAssignmentDiv.find('#SourceStaffID');
            var calendar = addSubstituteAssignmentDiv.find('#CalendarID');
            var sections = addSubstituteAssignmentDiv.find('#SelectedSectionIDs .dmsBackingData');

            var startDateValue = startDate.val();
            var endDateValue = endDate.val();
            var staffValue = skyward.controls.getValue(staff);
            var calendarValue = skyward.controls.getValue(calendar);
            var sectionValues = JSON.stringify(skyward.controls.getValue(sections));

            if (startDateValue !== null && endDateValue !== null && staffValue !== null && staffValue.length > 0)
            {
                var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));
                var entityID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenEntityID'));
                var schoolYearID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenSchoolYearID'));
                var excludeAssignedSections = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#ExcludeAssignedSections'));

                $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/UpdateTempSubstituteAssignments",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        tempTableName: tempTableGuid,
                        startDate: startDateValue.toString(),
                        endDate: endDateValue.toString(),
                        sourceStaffID: staffValue,
                        entityID: entityID,
                        schoolYearID: schoolYearID,
                        excludeAssignedSections: excludeAssignedSections,
                        calendarID: calendarValue,
                        selectedSectionIDs: sectionValues
                    },
                    success: function (response)
                    {
                        if (response.success)
                        {
                            skyward.browse.get("TempSubstituteAssignments", {});
                        }
                        else
                        {
                            var baseErrorContainer = addSubstituteAssignmentDiv.find('#baseWorkflowErrorContainer');
                            if (!baseErrorContainer.text())
                            {
                                skyward.validation.displayValidationMessages(response, addSubstituteAssignmentDiv, baseErrorContainer, null, null);
                            }
                        }
                    }
                });
            }
        }, 200);

        var applySubstituteSettingsToUnassignedSections = function ()
        {
            var addSubstituteAssignmentDiv = $(this).parents('#AddSubstituteAssignmentDiv');

            var hasGradebookAccess = addSubstituteAssignmentDiv.find('#HasGradebookAccess');
            var hasAttendanceAccess = addSubstituteAssignmentDiv.find('#HasAttendanceAccess');
            var isLongTermSubstitute = addSubstituteAssignmentDiv.find('#IsLongTermSubstitute');
            var hasConferenceAccess = addSubstituteAssignmentDiv.find('#HasConferenceAccess');
            var substituteStaff = addSubstituteAssignmentDiv.find('#SubstituteStaffID');
            var excludeFromStateReporting = addSubstituteAssignmentDiv.find('#ExcludeFromStateReporting');
            var isTSDLExclusion = addSubstituteAssignmentDiv.find('#IsTSDLExclusion');
            var substituteTeacherIndicator = addSubstituteAssignmentDiv.find('#SubstituteStateTeacherIndicatorWAID');
            var isInstructionalStaff = addSubstituteAssignmentDiv.find('#IsSubstituteInstructionalStaff');
            var doNotSendToEdFi = addSubstituteAssignmentDiv.find('#DoNotSendToEdFi');

            var hasGradebookAccessValue = skyward.controls.getValue(hasGradebookAccess);
            var hasAttendanceAccessValue = skyward.controls.getValue(hasAttendanceAccess);
            var isLongTermSubstituteValue = skyward.controls.getValue(isLongTermSubstitute);
            var hasConferenceAccessValue = skyward.controls.getValue(hasConferenceAccess);
            var substituteStaffValue = skyward.controls.getValue(substituteStaff);

            if (doNotSendToEdFi)
            {
                var doNotSentToEdFiValue = skyward.controls.getValue(doNotSendToEdFi);
            }

            if (excludeFromStateReporting)
            {
                var excludeFromStateReportingValue = skyward.controls.getValue(excludeFromStateReporting);
            }

            if (isTSDLExclusion)
            {
                var isTSDLExclusionValue = skyward.controls.getValue(isTSDLExclusion);
            }

            if (substituteTeacherIndicator)
            {
                var substituteIsInstructionalStaffValue = skyward.controls.getValue(isInstructionalStaff);
                if (substituteIsInstructionalStaffValue)
                {
                    var substituteTeacherIndicatorValue = skyward.controls.getValue(substituteTeacherIndicator);
                }
            }

            if (substituteStaffValue !== null && substituteStaffValue.length > 0)
            {
                var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));
                var entityID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenEntityID'));
                var schoolYearID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenSchoolYearID'));

                $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/ApplySubstituteSettingsToUnassignedSections",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        tempTableName: tempTableGuid,
                        substituteStaffID: substituteStaffValue,
                        substituteTeacherIndicatorID: substituteTeacherIndicatorValue,
                        substituteIsInstructionalStaff: substituteIsInstructionalStaffValue,
                        hasGradebookAccess: hasGradebookAccessValue,
                        hasAttendanceAccess: hasAttendanceAccessValue,
                        isLongTermSubstitute: isLongTermSubstituteValue,
                        hasConferenceAccess: hasConferenceAccessValue,
                        excludeFromStateReporting: excludeFromStateReportingValue,
                        isTSDLExclusion: isTSDLExclusionValue,
                        doNotSendToEdFi: doNotSentToEdFiValue,
                        entityID: entityID,
                        schoolYearID: schoolYearID
                    },
                    success: function (response)
                    {
                        if (response.success)
                        {
                            skyward.browse.get("TempSubstituteAssignments", {});
                        }
                        else
                        {
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            if (!baseErrorContainer.text())
                            {
                                skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                            }
                        }
                    }
                });
            }
        };

        var clearSubstituteSettingsAllSections = function ()
        {
            var addSubstituteAssignmentDiv = $(this).parents('#AddSubstituteAssignmentDiv');
            var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StaffMeet/ClearSubstituteSettingsAllSections",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    tempTableName: tempTableGuid
                },
                success: function (response)
                {
                    if (response.success)
                    {
                        $(document).one("browseLoaded.TempSubstituteAssignments", cleanUpSubAssignmentsBrowse);
                        skyward.browse.get("TempSubstituteAssignments", {});
                    }
                }
            });
        };

        var cleanUpSubAssignmentsBrowse = function ()
        {
            $("#TempSubstituteAssignments").find($('[id*="SubstituteStaffID-"]')).each(function (index, element)
            {
                if (element.value != "")
                {
                    skyward.controls.setValue($(element), "");
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="HasGradebookAccess-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="HasAttendanceAccess-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="IsLongTermSubstitute-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="HasConferenceAccess-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="IsInstructionalStaff-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="StateTeacherIndicatorWAID-"]')).each(function (index, element)
            {
                skyward.controls.clearValue($(element));
            });
        }

        skyward.scheduling.displayStaffMeetAssignmentConflictPopup = function ()
        {
            var button = $(this);
            var tempStaffMeetID = button.data().id;
            var massUpdateStaffForMeetsDiv = $('#MassUpdateStaffForMeetsDiv');
            var tempTableGuid = skyward.controls.getValue(massUpdateStaffForMeetsDiv.find('#HiddenTableName'));

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/DisplayStaffMeetAssignmentConflictInformation/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { TempStaffMeetID: JSON.stringify(tempStaffMeetID), tempTableName: tempTableGuid }
                });
            };

            var popupTitle = "Conflict Information";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        skyward.scheduling.displaySubstituteAssignmentConflictPopup = function ()
        {
            var button = $(this);
            var tempSubstituteAssignmentID = button.data().id;
            var addSubstituteAssignmentDiv = $('#AddSubstituteAssignmentDiv');
            var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/DisplaySubstituteAssignmentConflictInformation/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { TempSubstituteAssignmentID: JSON.stringify(tempSubstituteAssignmentID), tempTableName: tempTableGuid }
                });
            };

            var popupTitle = "Conflict Information";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        skyward.scheduling.redefaultSchedulingPriority = function ()
        {
            var schedulingPriorityCombobox = $('#editCourse_SchedulingPriorityCode');

            if (schedulingPriorityCombobox)
            {
                if (this.checked)
                {
                    schedulingPriorityCombobox.val(6);
                    schedulingPriorityCombobox.change();
                }
                else
                {
                    schedulingPriorityCombobox.val(3);
                    schedulingPriorityCombobox.change();
                }
            }
        };

        skyward.scheduling.newAnalysisTab = function ()
        {
            skyward.window.loadContent('popout', "Scheduling", "StudentAutoSchedulerRunAnalysis", "Details", skyward.controls.getValue($("#StudentAutoSchedulerRunAnalysisID")));
        };

        skyward.scheduling.quickentryschedulinggroupintoquickentry = function (event)
        {
            var codeEelValue = skyward.controls.getValue(event.data.schedulingGroupCodeEel);
            var quickAddScope = event.data.quickAddScope;
            var quickAddButton = event.data.addAnotherButton;

            if (codeEelValue)
            {
                var url = skyward.global.virtualDir + 'Scheduling/SchedulingGroup/GetCourseIDsForSchedulingGroup/' + codeEelValue;
                $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        success: function (data)
                        {
                            $.each(data, function (index, courseID)
                            {
                                var lastQuickEntryRow = getLastSCRQuickEntryTemplateRow(quickAddScope);
                                if (lastQuickEntryRow)
                                {
                                    var courseCodeEel = getSCRCourseCodeEel(lastQuickEntryRow);
                                    if (courseCodeEel)
                                    {
                                        var courseCodeEelValue = skyward.controls.getValue(courseCodeEel);

                                        if (courseCodeEelValue)
                                        {
                                            quickAddButton.click();
                                            skyward.controls.setValue(getSCRCourseCodeEel(getLastSCRQuickEntryTemplateRow(quickAddScope)), courseID);
                                        }
                                        else
                                        {
                                            skyward.controls.setValue(courseCodeEel, courseID);
                                            quickAddButton.click();
                                        }
                                    }
                                }
                            });
                        }
                    });
            }
        };

        var getLastSCRQuickEntryTemplateRow = function (scope)
        {
            return scope.find('tr.childrecordquickentryrow').filter(':last'); // Class of the TR for a given row of the table-based template
        };

        var getSCRCourseCodeEel = function (scope)
        {
            return scope.find('input.coursecodeeel').parent(); // CodeEel within ChildRecordQuickEntry only puts the class names on the input for the Value of the code eel.  We want the containing Div that "is" the code eel...
        };

        var massPrintStudentScheduleStaffSortPeriodPopup = function (event)
        {
            var button = $(this);
            var title = 'More Information';
            var options =
            {
                anchorTo: button,
                id: "MassPrintStudentScheduleStaffSortPeriodPopup"
            };

            var message = '<p><span class="boldFont">Group Schedules by Period</span><br/>' +
                'Select the Display Period used to group the printed schedules. Students sharing the same teacher during this period will be printed together.</p><br/>' +

                '<p><span class="boldFont">Override Schedule Dates For Teacher</span><br/>' +
                'By default, the <span class="boldFont">Schedule Start Date</span>  and <span class="boldFont">Schedule End Date</span> are used to identify the active primary teacher for the designated period. ' +
                'Check this option and use the <span class="boldFont">Start Date Override</span> and <span class="boldFont">End Date Override</span> fields to specify a separate date range for teacher selection. ' +
                'In the event a student has multiple active teachers within this timeframe, the system prioritizes teachers who are currently active, ' +
                'followed by the student\'s most recent class enrollment date, then the teacher\'s most recent assignment date.</p><br/>' +

                '<p class="italicFont">Example: If Display Period 1 is selected, all students sharing the same active teacher during that period for the given dates will have their schedules printed together, sorted alphabetically by student name.</p>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var restrictSchedulingBeyondSectionCapacityInformationPopup = function(event)
        {
            var button = $(this);
            var title = 'Restrict Scheduling Beyond Section Capacity';
            var options =
            {
                anchorTo: button,
                id: "RestrictSchedulingBeyondSectionCapacityInformationPopup"
            };

            var message = '<div class="boldFont">When enabled:</div>' +
                '<div>Only users in the selected security groups who have scheduling permissions can place students into sections that exceed the maximum seat capacity. Super users are not affected by this setting and can always schedule students into sections beyond the maximum seat capacity, regardless of whether they are part of the selected security groups.</div>' +
                '<div class="boldFont" style="margin-top:8px;">When disabled:</div>' +
                '<div>Any user with scheduling permissions can place students into sections that exceed the maximum seat capacity.</div>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var massAutoSchedulerAlternateRequestPopup = function (event)
        {
            var button = $(this);
            var title = 'More Information';
            var options =
            {
                anchorTo: button,
                id: "MassAutoSchedulerAlternateRequestPopup"
            };

            var message = '<div class="boldFont">Do Not Process Alternate Requests</div>' +
                '<div>By selecting this option, the Mass Student Scheduler WILL NOT process the students\' alternate requests\n to fill in any gaps they may have on their schedules.\n\n</div>' +

            '<div class="boldFont">Process Alternates After All Regular Requests</div>' +
            '<div>When this option is selected, the Mass Student Scheduler will process students\' alternate requests after \ncompleting all regular requests for the included students. ' +
            'It processes every student\'s regular course \nrequests, then moves on to alternate requests to fill any remaining gaps. This approach gives students the \nbest chance of ' +
            'getting their preferred courses but may result in more schedules with open periods.\n\n</div>' +

            '<div class="italicFont">Example: Two students have been selected to run in the Mass Student Scheduler with the option to Process \nAlternates After All Regular Requests. The system begins with the ' +
            'first student, processing all his regular \ncourse requests. After completing their requests, it moves on to the second student and processes their regular requests. \nOnce ' +
            'both students\' regular requests are complete, the system then processes their \nalternate requests to fill any remaining gaps.\n\n</div> ' +

            '<div class="boldFont">Process Alternates By Individual Student</div>' +
            '<div>When this option is selected, the Mass Student Scheduler will process each student\'s alternate requests \nimmediately after their regular requests, before moving on to the ' +
            'next student. This approach aims to \ncreate more complete schedules but may increase conflicts for regular course requests for students processed later in the run.\n\n</div> ' +

            '<div class="italicFont">Example: Two students have been selected to run in the Mass Student Scheduler with the option to Process \nAlternates By Individual Student. The system begins with the first student, ' +
            'processing all their regular course \nrequests. After completing their regular requests, the system immediately processes their alternate \nrequests. Once both the first student\'s regular ' +
            'and alternate requests have been processed, the system then moves on \nto the second student, following the same sequence.</div>'



            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var legacyStudentSectionDropStatusInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Legacy Student Section Drop Status Information';
            var options =
            {
                anchorTo: button,
                id: "LegacyStudentSectionDropStatusInformationPopup"
            };

            var message = '<div class="boldFont">Enabled (Legacy Calculation):</div>' +
                '<div>A Student Section is shown as Dropped if any of its enrollment records has an Early Exit Reason that is marked as a drop, ' +
                'even if a more recent enrollment record does not have a drop reason. This means that once a student is dropped during any part of their enrollment, ' +
                'the Student Section will always display as Dropped.\n\n</div>' +
                '<div class="boldFont">Disabled (Updated Calculation):</div>' +
                '<div>A Student Section is shown as Dropped only when the student\'s most recent enrollment record has an Early Exit Reason that is marked as a drop. ' +
                'This means that if a student is dropped and later re-enrolled in the same section, the Student Section will no longer display as Dropped.</div>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        // Event handlers
        var events =
        {
            "newAnalysisTab": skyward.scheduling.newAnalysisTab,
            "displayStaffMeetAssignmentConflictPopup": skyward.scheduling.displayStaffMeetAssignmentConflictPopup,
            "displaySubstituteAssignmentConflictPopup": skyward.scheduling.displaySubstituteAssignmentConflictPopup,
            "massAutoSchedulerAlternateRequestPopup": massAutoSchedulerAlternateRequestPopup,
            "massPrintStudentScheduleStaffSortPeriodPopup": massPrintStudentScheduleStaffSortPeriodPopup,
            "massChangeEndDateBlurEvent": skyward.scheduling.massChangeEndDateBlurEvent,
            "updateIndividualTempSubstituteAssignment": skyward.scheduling.updateIndividualTempSubstituteAssignment,
            "legacyStudentSectionDropStatusInformationPopup": legacyStudentSectionDropStatusInformationPopup,
            "restrictSchedulingBeyondSectionCapacityInformationPopup": restrictSchedulingBeyondSectionCapacityInformationPopup
        };
        skyward.events.registerEvents("scheduling", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
